module.exports = __webpack_public_path__ + "assets/img/mobile.363c7460.svg";